import React from 'react';
import InsightCard from './InsightCard';
import MetricTable from './MetricTable';
import { cardSurfaceClass, cx, domainHeaderClasses } from '../theme';

const insightLayoutClasses = {
  stack: 'space-y-3',
  split: 'grid gap-4 lg:grid-cols-2',
  grid: 'grid gap-4 lg:grid-cols-2',
};

function splitSectionTitle(title) {
  const parts = String(title || '').split(' - ');
  if (parts.length < 2) {
    return {
      eyebrow: title,
      headline: '',
    };
  }

  return {
    eyebrow: parts[0],
    headline: parts.slice(1).join(' - '),
  };
}

export default function DomainSection({ section }) {
  const { eyebrow, headline } = splitSectionTitle(section.title);

  return (
    <section data-coo="domain-section" className={cx(cardSurfaceClass, 'overflow-hidden')}>
      <div
        className={cx(
          'border-b px-5 py-4',
          domainHeaderClasses[section.tone] || domainHeaderClasses.tower,
        )}
      >
        <span data-coo="section-title" className="sr-only">
          {section.title}
        </span>
        <div className="space-y-1">
          <div className="text-[10px] font-semibold uppercase tracking-[0.08em] opacity-80">
            {eyebrow}
          </div>
          {headline ? (
            <div className="text-[13px] font-semibold tracking-[0.01em]">
              {headline}
            </div>
          ) : null}
        </div>
      </div>
      <div className="space-y-4 px-5 py-4">
        {section.blocks.map((block, blockIndex) => {
          if (block.type === 'table') {
            return <MetricTable key={`${section.id}-table-${blockIndex}`} table={block.table} />;
          }

          if (block.type === 'insights') {
            return (
              <div
                key={`${section.id}-insights-${blockIndex}`}
                className={cx(insightLayoutClasses[block.layout] || insightLayoutClasses.stack, block.spaced ? 'mb-3' : '')}
              >
                {block.items.map((insight) => (
                  <InsightCard key={`${section.id}-${insight.title}`} insight={insight} />
                ))}
              </div>
            );
          }

          return (
            <p key={`${section.id}-note-${blockIndex}`} className="text-[12px] leading-relaxed text-slate-500">
              {block.text}
            </p>
          );
        })}
      </div>
    </section>
  );
}
